<template>
  <div class="gift-this-donation">
    <CheckBox
      :label="$t('giftDonation.checkLabel')"
      v-model="giftDonation"
    />
    <TransitionSlide>
      <div v-if="giftDonation">
        <h4>{{ $t('giftDonation.name.title') }}</h4>
        <FormField
          :label="$t('giftDonation.name.label')"
          v-model="giftData.name"
          :validation="v$.giftData.name"
        />
      </div>
    </TransitionSlide>
  </div>
</template>

<script>
import CheckBox from '@/components/form/CheckBox'
import FormField from '@/components/form/FormField'
import TransitionSlide from '@/transitions/Slide'
import { requiredIf } from '@vuelidate/validators'
import useVuelidate from '@vuelidate/core'
import { useDonationStore } from '@/stores/donation'
import { ref } from 'vue'

export default {
  name: 'GiftDonation',
  components: {
    CheckBox, FormField, TransitionSlide
  },
  setup () {
    const donationStore = useDonationStore()
    const giftDonation = ref(false)
    const giftData = ref({ name: null })
    return { donationStore, v$: useVuelidate(), giftDonation, giftData }
  },
  validations () {
    return {
      giftData: {
        name: { required: requiredIf(function () { return this.giftDonation }) },
      }
    }
  },
  computed: {
    fieldsInvalid () { return this.v$.$invalid }
  },
  watch: {
    giftDonation: function (val) {
      if (val === false) {
        this.donationStore.setGiftDonation(null)
        this.giftData = { name: null }
      }
    },
    'giftData.name': function (_val) {
      if (!this.fieldsInvalid && this.giftDonation) {
        this.donationStore.setGiftDonation(`${this.giftData.name}`)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .gift-this-donation {
    margin-top: 1rem;

    h4 {
      color: white;
      font-family: var(--titles-font-family-medium);
      margin-bottom: 0.1rem;
    }

    .form-check {
      padding-top: 0.5em;
    }
  }
</style>
